export default "__VITE_ASSET__CrEolSQk__"